// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .p-ripple {
    opacity: 0;
} */

.p-tabview .p-tabview-nav li {
  margin-left: 5px !important;
}

.p-tabview .p-tabview-nav {
  position: absolute;
  z-index: 1;
}

.p-tabview .p-tabview-nav li {
  margin-left: -15px !important;
  padding: 0px 15px 0px 15px;
  position: relative;
  /* bottom: 2px; */
  top: 6px;
  margin-right: -4px !important;

  &:first-child {
    bottom: 0.04rem;
  }
}

.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  font-size: 12px !important;
  background-color: #ffe600;
  font-weight: 400;
  color: #212529 !important;
  border: none !important;
  /* border: 1px solid #ffe600 !important; */
}
/* p-table table tbody tr td:nth-child(4) select,
p-table table tbody tr td:nth-child(2) select {
  display: none;
} */

.btn-like-link {
  background-color: #6495ed;
}
.rightbtns {
  position: relative;
  left: 10px;
  .gobackbtn {
    padding: 10px 24px;
    border-top-right-radius: 3px !important;
    border-top-left-radius: 3px !important;
  }
  .savebtn {
    padding: 10px 30px;
    border-top-right-radius: 3px !important;
    border-top-left-radius: 3px !important;
  }
}
.initialgrid {
  border-bottom: none !important;
  overflow: hidden;
  .p-datatable-thead th:nth-child(5) {
    width: 37.5%;
  }
  .p-datatable-thead th:nth-child(6) {
    width: 28.5%;
  }
}

.bsgrid {
  .p-datatable-thead th:nth-child(6) {
    width: 36% !important;
  }
}
.firstgrid {
  border-bottom: none !important;
}
.secondgrid {
  .firsttb {
    .p-datatable-thead th:nth-child(5) {
      padding-right: 62px !important;
    }
  }
  .p-datatable-thead th:nth-child(5) {
    padding-right: 42px !important;
  }
}
.p-datatable .p-datatable-tbody > tr > td:nth-child(6) {
  padding-right: 10px !important;
}
.secondgrid {
  border-left: 1px solid black !important;
  border-right: 1px solid black !important;
  border-bottom: 1px solid black !important;
  border-top: none !important;
  .secondtb {
    .fa-times {
      color: #ff0000;
    }
    select {
      margin-top: 1px;
    }
  }
  .p-datatable .p-datatable-thead > tr > th:nth-child(1),
  .p-datatable .p-datatable-thead > tr > th:nth-child(2),
  .p-datatable .p-datatable-thead > tr > th:nth-child(3),
  .p-datatable .p-datatable-thead > tr > th:nth-child(4),
  .p-datatable .p-datatable-thead > tr > th:nth-child(6) {
    visibility: hidden;
  }
  .p-datatable-tbody > tr:nth-child(odd) {
    background: #fff !important;
  }
  .p-datatable-tbody > tr:nth-child(even) {
    background: #f5f5f5 !important;
  }
  .p-datatable-thead th {
    background: #fff !important;
  }
}
.tablegrid {
  margin-left: 15px;
}
.tablegridplsection {
  .maximize-button {
    .secondgrid {
      background: #fff;
    }
  }
}
.minimized {
  .maximize-button {
    right: -12px !important;
    position: absolute;
    top: 15px;
    z-index: 1;
    background: none;
    border: none;
    font-size: 20px;
  }
}
.maximized {
  .maximize-button {
    z-index: 10000;
    position: absolute;
    right: 1px !important;
    top: 14px;
    background: none;
    border: none;
    font-size: 20px;
  }
  .PadLNull {
    padding-right: 0;
  }
  background: #fff;
}
.tablegridbssection {
  .maximize-button {
    .secondgrid {
      background: #fff;
    }
  }
  .full {
    overflow: hidden;
  }
}
.maximized {
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
  overflow: auto;
  margin-left: 1px !important;
  .PadLNull {
    overflow: visible;
    width: 100%;
    /* max-width: 100% !important; */
  }
  .secondgrid {
    background: #fff;
  }
  .rightbtnsbtm {
    margin-bottom: 30px !important;
  }
}

.minimized {
  height: 50%;
  position: relative;
  z-index: 1;
}
.maximized {
  .modify {
    display: none;
  }
  .modifybtn {
    display: none;
  }
}
.minimized {
  .maxintable {
    left: -15px !important;
    top: 94px !important;
  }
}
.maximized {
  .maxintable {
    right: 30px !important;
    top: 97px !important;
  }
}

.minimized {
  .maxintablebs {
    margin-top: 77px !important;
    margin-right: 33.5% !important;
  }
}

.maximized {
  .maxintablebs {
    right: 30px !important;
    top: 97px !important;
  }
}
.addstdbtn {
  border-radius: 10px !important;
  padding: 5px;
  width: 50%;
  font-size: 16px !important;
  color: black;
  background-color: #ccc;

  &:focus {
    background-color: #ffe600 !important;
    box-shadow: none;
  }
}

#inputIdPl {
  border-color: red !important;
}

#inputIdBs {
  border-color: red !important;
}
.cancelbtn {
  background-color: #dedede !important;
  border: 1px solid #ccc!important;
}

.yesbtn{
  background-color: #ffe600 !important;
  border: 1px solid #ffe600 !important;
}
.popUpCancel {
  width: 400px !important;
}
.dropdownlabelfont{
  color: black;
  font-size: 16px;
  font-weight: 100;
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/plugandplay/plugandplay.component.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,6BAA6B;;EAE7B;IACE,eAAe;EACjB;AACF;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,0CAA0C;AAC5C;AACA;;;GAGG;;AAEH;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV;IACE,kBAAkB;IAClB,uCAAuC;IACvC,sCAAsC;EACxC;EACA;IACE,kBAAkB;IAClB,uCAAuC;IACvC,sCAAsC;EACxC;AACF;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE,8BAA8B;AAChC;AACA;EACE;IACE;MACE,8BAA8B;IAChC;EACF;EACA;IACE,8BAA8B;EAChC;AACF;AACA;EACE,8BAA8B;AAChC;AACA;EACE,uCAAuC;EACvC,wCAAwC;EACxC,yCAAyC;EACzC,2BAA2B;EAC3B;IACE;MACE,cAAc;IAChB;IACA;MACE,eAAe;IACjB;EACF;EACA;;;;;IAKE,kBAAkB;EACpB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE;MACE,gBAAgB;IAClB;EACF;AACF;AACA;EACE;IACE,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;AACF;AACA;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA,gBAAgB;AAClB;AACA;EACE;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,cAAc;EACd,2BAA2B;EAC3B;IACE,iBAAiB;IACjB,WAAW;IACX,gCAAgC;EAClC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;AACA;EACE,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,0BAA0B;EAC1B,YAAY;EACZ,sBAAsB;;EAEtB;IACE,oCAAoC;IACpC,gBAAgB;EAClB;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["/* .p-ripple {\r\n    opacity: 0;\r\n} */\r\n\r\n.p-tabview .p-tabview-nav li {\r\n  margin-left: 5px !important;\r\n}\r\n\r\n.p-tabview .p-tabview-nav {\r\n  position: absolute;\r\n  z-index: 1;\r\n}\r\n\r\n.p-tabview .p-tabview-nav li {\r\n  margin-left: -15px !important;\r\n  padding: 0px 15px 0px 15px;\r\n  position: relative;\r\n  /* bottom: 2px; */\r\n  top: 6px;\r\n  margin-right: -4px !important;\r\n\r\n  &:first-child {\r\n    bottom: 0.04rem;\r\n  }\r\n}\r\n\r\n.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\r\n  font-size: 12px !important;\r\n  background-color: #ffe600;\r\n  font-weight: 400;\r\n  color: #212529 !important;\r\n  border: none !important;\r\n  /* border: 1px solid #ffe600 !important; */\r\n}\r\n/* p-table table tbody tr td:nth-child(4) select,\r\np-table table tbody tr td:nth-child(2) select {\r\n  display: none;\r\n} */\r\n\r\n.btn-like-link {\r\n  background-color: #6495ed;\r\n}\r\n.rightbtns {\r\n  position: relative;\r\n  left: 10px;\r\n  .gobackbtn {\r\n    padding: 10px 24px;\r\n    border-top-right-radius: 3px !important;\r\n    border-top-left-radius: 3px !important;\r\n  }\r\n  .savebtn {\r\n    padding: 10px 30px;\r\n    border-top-right-radius: 3px !important;\r\n    border-top-left-radius: 3px !important;\r\n  }\r\n}\r\n.initialgrid {\r\n  border-bottom: none !important;\r\n  overflow: hidden;\r\n  .p-datatable-thead th:nth-child(5) {\r\n    width: 37.5%;\r\n  }\r\n  .p-datatable-thead th:nth-child(6) {\r\n    width: 28.5%;\r\n  }\r\n}\r\n\r\n.bsgrid {\r\n  .p-datatable-thead th:nth-child(6) {\r\n    width: 36% !important;\r\n  }\r\n}\r\n.firstgrid {\r\n  border-bottom: none !important;\r\n}\r\n.secondgrid {\r\n  .firsttb {\r\n    .p-datatable-thead th:nth-child(5) {\r\n      padding-right: 62px !important;\r\n    }\r\n  }\r\n  .p-datatable-thead th:nth-child(5) {\r\n    padding-right: 42px !important;\r\n  }\r\n}\r\n.p-datatable .p-datatable-tbody > tr > td:nth-child(6) {\r\n  padding-right: 10px !important;\r\n}\r\n.secondgrid {\r\n  border-left: 1px solid black !important;\r\n  border-right: 1px solid black !important;\r\n  border-bottom: 1px solid black !important;\r\n  border-top: none !important;\r\n  .secondtb {\r\n    .fa-times {\r\n      color: #ff0000;\r\n    }\r\n    select {\r\n      margin-top: 1px;\r\n    }\r\n  }\r\n  .p-datatable .p-datatable-thead > tr > th:nth-child(1),\r\n  .p-datatable .p-datatable-thead > tr > th:nth-child(2),\r\n  .p-datatable .p-datatable-thead > tr > th:nth-child(3),\r\n  .p-datatable .p-datatable-thead > tr > th:nth-child(4),\r\n  .p-datatable .p-datatable-thead > tr > th:nth-child(6) {\r\n    visibility: hidden;\r\n  }\r\n  .p-datatable-tbody > tr:nth-child(odd) {\r\n    background: #fff !important;\r\n  }\r\n  .p-datatable-tbody > tr:nth-child(even) {\r\n    background: #f5f5f5 !important;\r\n  }\r\n  .p-datatable-thead th {\r\n    background: #fff !important;\r\n  }\r\n}\r\n.tablegrid {\r\n  margin-left: 15px;\r\n}\r\n.tablegridplsection {\r\n  .maximize-button {\r\n    .secondgrid {\r\n      background: #fff;\r\n    }\r\n  }\r\n}\r\n.minimized {\r\n  .maximize-button {\r\n    right: -12px !important;\r\n    position: absolute;\r\n    top: 15px;\r\n    z-index: 1;\r\n    background: none;\r\n    border: none;\r\n    font-size: 20px;\r\n  }\r\n}\r\n.maximized {\r\n  .maximize-button {\r\n    z-index: 10000;\r\n    position: absolute;\r\n    right: 1px !important;\r\n    top: 14px;\r\n    background: none;\r\n    border: none;\r\n    font-size: 20px;\r\n  }\r\n  .PadLNull {\r\n    padding-right: 0;\r\n  }\r\n  background: #fff;\r\n}\r\n.tablegridbssection {\r\n  .maximize-button {\r\n    .secondgrid {\r\n      background: #fff;\r\n    }\r\n  }\r\n  .full {\r\n    overflow: hidden;\r\n  }\r\n}\r\n.maximized {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 1;\r\n  overflow: auto;\r\n  margin-left: 1px !important;\r\n  .PadLNull {\r\n    overflow: visible;\r\n    width: 100%;\r\n    /* max-width: 100% !important; */\r\n  }\r\n  .secondgrid {\r\n    background: #fff;\r\n  }\r\n  .rightbtnsbtm {\r\n    margin-bottom: 30px !important;\r\n  }\r\n}\r\n\r\n.minimized {\r\n  height: 50%;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n.maximized {\r\n  .modify {\r\n    display: none;\r\n  }\r\n  .modifybtn {\r\n    display: none;\r\n  }\r\n}\r\n.minimized {\r\n  .maxintable {\r\n    left: -15px !important;\r\n    top: 94px !important;\r\n  }\r\n}\r\n.maximized {\r\n  .maxintable {\r\n    right: 30px !important;\r\n    top: 97px !important;\r\n  }\r\n}\r\n\r\n.minimized {\r\n  .maxintablebs {\r\n    margin-top: 77px !important;\r\n    margin-right: 33.5% !important;\r\n  }\r\n}\r\n\r\n.maximized {\r\n  .maxintablebs {\r\n    right: 30px !important;\r\n    top: 97px !important;\r\n  }\r\n}\r\n.addstdbtn {\r\n  border-radius: 10px !important;\r\n  padding: 5px;\r\n  width: 50%;\r\n  font-size: 16px !important;\r\n  color: black;\r\n  background-color: #ccc;\r\n\r\n  &:focus {\r\n    background-color: #ffe600 !important;\r\n    box-shadow: none;\r\n  }\r\n}\r\n\r\n#inputIdPl {\r\n  border-color: red !important;\r\n}\r\n\r\n#inputIdBs {\r\n  border-color: red !important;\r\n}\r\n.cancelbtn {\r\n  background-color: #dedede !important;\r\n  border: 1px solid #ccc!important;\r\n}\r\n\r\n.yesbtn{\r\n  background-color: #ffe600 !important;\r\n  border: 1px solid #ffe600 !important;\r\n}\r\n.popUpCancel {\r\n  width: 400px !important;\r\n}\r\n.dropdownlabelfont{\r\n  color: black;\r\n  font-size: 16px;\r\n  font-weight: 100;\r\n  margin-top: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
